export const handleFallback = (properties: Record<string, unknown>) => {
  const result: Record<string, unknown> = {};
  const falseValues = [0, false];
  for (const [key, value] of Object.entries(properties)) {
    result[key] = falseValues.includes(value as number | boolean)
      ? value
      : value || undefined;
  }
  return result;
};
